import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useTranslation } from "react-i18next";
import AppHeader from "@/components/AppHeader";
import WishlistSection from "@/components/wishlist/WishlistSection";
import { Loader2 } from "lucide-react";

const Wishlists = () => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (!authLoading && !user) navigate("/auth");
  }, [authLoading, user, navigate]);

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="animate-spin text-muted-foreground" size={24} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background relative">
      {/* Decorative background — matching guest page */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.4]"
        style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, hsl(var(--primary) / 0.07) 1px, transparent 0)`,
          backgroundSize: "28px 28px",
        }}
      />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: `
            radial-gradient(ellipse 60% 50% at 0% 0%, hsl(var(--primary) / 0.04), transparent),
            radial-gradient(ellipse 50% 40% at 100% 100%, hsl(var(--primary) / 0.03), transparent)
          `,
        }}
      />

      <div className="relative z-10">
        <AppHeader onBack="/dashboard" userMenuVariant="dashboard" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
          {/* Page heading */}
          <div className="text-center sm:text-start mb-8">
            <p className="text-[10px] font-light uppercase tracking-[0.35em] text-muted-foreground mb-1">
              {t("wishlist.subtitle", { defaultValue: "Your Collections" })}
            </p>
            <h1 className="text-2xl sm:text-3xl font-bold text-foreground font-serif">
              {t("wishlist.pageTitle", { defaultValue: "Wish lists" })}
            </h1>
          </div>

          <WishlistSection />
        </div>
      </div>
    </div>
  );
};

export default Wishlists;
